import ModelBaseClass from "@quasidea/oas-client-react/lib/ModelBaseClass";
import CashAccountSearchRequest from "../CashAccountSearchRequest";
import ModelProxyClass from "./ModelProxyClass";
import ResultParameter from "../ResultParameter";


/**
 * @class CashAccountSearchRequestBase
 * @extends ModelBaseClass
 * @property {['Person'|'MachineRecord'|'Bank'|'Vault'|'Offage']} types at least one type is required
 * @property {number} tenantId (int64) required
 * @property {boolean} includeInactiveFlag
 * @property {string} smartFilter
 * @property {number} filterByMachineRecordLocationId (int64) optional, only usable if type is MachineRecord (otherwise this is ignored)
 * @property {'Vgt'|'Rt'} filterByMachineRecordType optional, only usable if type is MachineRecord (otherwise this is ignored)
 * @property {number} filterByVaultTechnicianPersonId (int64) optional, only usable if type is Vault (otherwise this is ignored).  If PersonId specified is Admin, this is also ignored.
 * @property {ResultParameter} resultParameter [Name,VgtSpotName]
 */
class CashAccountSearchRequestBase extends ModelBaseClass {
	/**
	 * at least one type is required
	 * @type {['Person'|'MachineRecord'|'Bank'|'Vault'|'Offage']} types
	 */
	types;
	/**
	 * required
	 * @type {number} tenantId (int64)
	 */
	tenantId;
	/**
	 * @type {boolean} includeInactiveFlag
	 */
	includeInactiveFlag;
	/**
	 * @type {string} smartFilter
	 */
	smartFilter;
	/**
	 * optional, only usable if type is MachineRecord (otherwise this is ignored)
	 * @type {number} filterByMachineRecordLocationId (int64)
	 */
	filterByMachineRecordLocationId;
	/**
	 * optional, only usable if type is MachineRecord (otherwise this is ignored)
	 * @type {'Vgt'|'Rt'} filterByMachineRecordType
	 */
	filterByMachineRecordType;
	/**
	 * optional, only usable if type is Vault (otherwise this is ignored).  If PersonId specified is Admin, this is also ignored.
	 * @type {number} filterByVaultTechnicianPersonId (int64)
	 */
	filterByVaultTechnicianPersonId;
	/**
	 * [Name,VgtSpotName]
	 * @type {ResultParameter} resultParameter
	 */
	resultParameter;

	/**
	 * Instantiates a new instance of CashAccountSearchRequest based on the generic object being passed in (typically from a JSON object)
	 * @param {object} genericObject
	 * @return {CashAccountSearchRequest}
	 */
	static create(genericObject) {
		const newCashAccountSearchRequest = new CashAccountSearchRequest();
		newCashAccountSearchRequest.instantiate(_modelDefinition, genericObject, ModelProxyClass.createByClassName);
		return newCashAccountSearchRequest;
	}

	/**
	 * Instantiates a new array of CashAccountSearchRequest based on the generic array being passed in (typically from a JSON array)
	 * @param {[object]} genericArray
	 * @return {[CashAccountSearchRequest]}
	 */
	static createArray(genericArray) {
		if (genericArray === null) {
			return null;
		}

		const newCashAccountSearchRequestArray = [];
		genericArray.forEach(genericObject => {
			newCashAccountSearchRequestArray.push(CashAccountSearchRequest.create(genericObject));
		});
		return newCashAccountSearchRequestArray;
	}
}

/**
 * @type {string} OrderByName
 */
CashAccountSearchRequestBase.OrderByName = 'name';

/**
 * @type {string} OrderByVgtSpotName
 */
CashAccountSearchRequestBase.OrderByVgtSpotName = 'vgtspotname';

const _modelDefinition = [
	ModelBaseClass.createModelProperty('types', '[string]'),
	ModelBaseClass.createModelProperty('tenantId', 'integer'),
	ModelBaseClass.createModelProperty('includeInactiveFlag', 'boolean'),
	ModelBaseClass.createModelProperty('smartFilter', 'string'),
	ModelBaseClass.createModelProperty('filterByMachineRecordLocationId', 'integer'),
	ModelBaseClass.createModelProperty('filterByMachineRecordType', 'string'),
	ModelBaseClass.createModelProperty('filterByVaultTechnicianPersonId', 'integer'),
	ModelBaseClass.createModelProperty('resultParameter', 'ResultParameter'),
];

export default CashAccountSearchRequestBase;
